// `?expanded=true` opens a feed page with its search prompt panel showing, so the link is shareable.
export const EXPANDED_PROMPT_PARAM = 'expanded';

export function feedPagePath(feedId: string, options: { expanded?: boolean } = {}): string {
  const path = `/feeds/${encodeURIComponent(feedId)}`;
  return options.expanded ? `${path}?${EXPANDED_PROMPT_PARAM}=true` : path;
}

export function isPromptExpanded(params: URLSearchParams): boolean {
  return params.get(EXPANDED_PROMPT_PARAM) === 'true';
}

export function withPromptExpanded(params: URLSearchParams, expanded: boolean): URLSearchParams {
  const next = new URLSearchParams(params);
  if (expanded) next.set(EXPANDED_PROMPT_PARAM, 'true');
  else next.delete(EXPANDED_PROMPT_PARAM);
  return next;
}
